import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {InsoleModelGabaritShoeSizeSummaryModel} from "./insoleModelGabaritShoeSizeSummary.model";
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";

@Injectable({
    providedIn: 'root'
})
export class InsoleModelGabaritShoeSizeSummaryConverter extends HttpModelConverter<InsoleModelGabaritShoeSizeSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): InsoleModelGabaritShoeSizeSummaryModel {
        return new InsoleModelGabaritShoeSizeSummaryModel();
    }

    protected enrichObject(result: InsoleModelGabaritShoeSizeSummaryModel, src: InsoleModelGabaritShoeSizeSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.gabarit = this.lovValueSummaryConverter.convert(src.gabarit);
        result.shoeSize = this.lovValueSummaryConverter.convert(src.shoeSize);
    }
}
